import React from 'react';
import { formatCategoryLabel } from './api';
import CategoryIcon from './CategoryIcon';
import { t } from './i18n';

const COLORS = {
  primary: '#1a4d8f',
  muted: '#6b7280',
  border: '#e5e7eb',
};

// Build a path URL with the given filters
function listUrl(filters) {
  const qs = new URLSearchParams();
  Object.entries(filters).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') qs.append(k, v);
  });
  return `/list${qs.toString() ? `?${qs.toString()}` : ''}`;
}

// Breadcrumb: Home > Country > State > City > Area > Category [> Place Name]
// Pass either `establishment` (detail page) OR `filters` (list page)
export default function Breadcrumbs({ establishment, filters }) {
  const e = establishment || {};
  const f = filters || {};

  // Source values from establishment when available, otherwise filters
  const country = e.country || f.country;
  const state = e.state || f.state;
  const city = e.city || f.city;
  const area = e.area || f.area;
  const type = e.type || f.type;
  const placeName = e.name;

  const crumbs = [{ label: t('Home'), href: '/' }];

  if (country) crumbs.push({ label: country, href: listUrl({ country }) });
  if (state) crumbs.push({ label: state, href: listUrl({ country, state }) });
  if (city) crumbs.push({ label: city, href: listUrl({ country, state, city }) });
  if (area) crumbs.push({ label: area, href: listUrl({ country, state, city, area }) });
  if (type) {
    crumbs.push({
      label: <><CategoryIcon type={type} /> {formatCategoryLabel(type)}</>,
      href: listUrl({ country, state, city, area, type }),
    });
  }
  if (placeName) crumbs.push({ label: placeName, href: null });

  // Only home + nothing else = boring, don't show
  if (crumbs.length <= 1) return null;

  return (
    <nav style={{ fontSize: 13, color: COLORS.muted, marginBottom: 16, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 4 }} aria-label={t('Breadcrumb')}>
      {crumbs.map((c, idx) => (
        <React.Fragment key={idx}>
          {idx > 0 && <span style={{ color: COLORS.border, margin: '0 4px' }}>›</span>}
          {c.href ? (
            <a
              href={c.href}
              style={{ color: COLORS.primary, textDecoration: 'none', fontWeight: idx === 0 ? 400 : 500 }}
              onMouseEnter={(e) => { e.target.style.textDecoration = 'underline'; }}
              onMouseLeave={(e) => { e.target.style.textDecoration = 'none'; }}
            >
              {c.label}
            </a>
          ) : (
            <span style={{ color: '#1f2937', fontWeight: 600 }}>{c.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
}
